// extracted by mini-css-extract-plugin
export var survey = "survey-page-module--survey--d8097";
export var wrapper = "survey-page-module--wrapper--f5424";